import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { chevronUp } from '@primeicons/core/chevron-up';

@Component({
    selector: 'svg[data-p-icon="chevron-up"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class ChevronUp extends CoreIcon {
    constructor() {
        super();
        this._icon = chevronUp;
    }
}
